import { gql } from 'graphql-request';

export default gql`
  fragment Hero on ImageObjectType {
    title
    xl: rendition(fill: "1920x800-c100") {
      url
    }
    md: rendition(fill: "1280x830-c100") {
      url
    }
    sm: rendition(fill: "768x500-c100") {
      url
    }
    xs: rendition(fill: "640x300-c100") {
      url
    }
  }
`;
